// 셀프 입점·요금제 화면 글 한 벌 — 랜딩·/pricing·설정·대시보드가 같은 문구를 쓴다(한도 숫자는 core FREE_PLAN_LIMITS 에서 만든다).

import { formatBytes } from "@buildpy/core/modules/plan/usage-limit";
import { FREE_PLAN_LIMITS, PLAN_LABEL } from "@buildpy/core/modules/plan/types";

export { FORGOT_PASSWORD_PATH, SIGNUP_VERIFY_PATH } from "@buildpy/core/modules/onboarding/rules";
export { PLAN_SETTINGS_PATH } from "@buildpy/core/modules/plan/usage-mail";

export const SIGNUP_PATH = "/signup";
export const ONBOARDING_PATH = "/onboarding";
export const PRICING_PATH = "/pricing";
export const TERMS_PATH = "/terms";
export const PRIVACY_PATH = "/privacy";
export const PLAN_INTEREST_PATH = "/app/settings/plan-interest";

export const SIGNUP_CTA = { href: SIGNUP_PATH, label: "무료로 시작하기" } as const;
// 로그인한 사람이 공개 화면에서 앱으로 돌아가는 버튼.
export const APP_CTA = { href: "/app", label: "내 현장으로" } as const;

export const FREE_STORAGE_LABEL = formatBytes(FREE_PLAN_LIMITS.storage_limit_bytes);
export const FREE_NOTIFY_LABEL = `월 ${FREE_PLAN_LIMITS.notify_month_limit}건`;
// 「사진 1GB · 알림톡 월 30건」
export const FREE_LIMITS_LINE = `사진 ${FREE_STORAGE_LABEL} · 알림톡 ${FREE_NOTIFY_LABEL}`;

export const FREE_PLAN = {
  name: PLAN_LABEL.free,
  who: "처음 써 보는 시공사",
  price: "0원",
  priceNote: "카드 등록 없이 바로 시작",
  points: ["기능 전부", "현장·고객·멤버 제한 없음", `사진 저장 ${FREE_STORAGE_LABEL}`, `알림톡 ${FREE_NOTIFY_LABEL}`],
} as const;

// 랜딩 요금 카드(시안 V3) — 무료는 체크 4줄, 준비 중 요금제는 「기능은 무료와 같아요」 + 한도 두 줄.
export const LANDING_FREE_BADGE = "지금 쓸 수 있어요";
export const LANDING_FREE_POINTS = [FREE_PLAN.priceNote, "기능 전부", "현장·고객·직원 수 제한 없음", `사진 저장 ${FREE_STORAGE_LABEL} · 알림톡 ${FREE_NOTIFY_LABEL}`] as const;
export const LANDING_SAME_FEATURES = "기능은 무료와 같아요";

export const PREPARING_PLANS = [
  { key: "pro", name: PLAN_LABEL.pro, who: "현장을 동시에 여러 개 돌리는 시공사", more: "사진·알림톡이 더 필요할 때", limit: "무료보다 넉넉하게" },
  { key: "max", name: PLAN_LABEL.max, who: "사진·알림이 많은 시공사", more: "현장이 많고 고객 알림을 자주 보낼 때", limit: "가장 넉넉하게" },
] as const;

export const PLAN_SAME_FEATURES = "모든 요금제에서 기능은 같습니다 · 한도를 넘어도 막지 않고 알려 드립니다";

export const PRICING_FAQ = [
  { q: "무료는 언제까지인가요?", a: "무료 요금제는 계속 남습니다. 유료 요금제가 나와도 무료로 쓰던 데이터와 기능은 그대로입니다." },
  { q: "한도를 넘으면 쓸 수 없나요?", a: "막지 않습니다. 80%와 100%에서 알려 드리고, 사진도 알림톡도 계속 나갑니다." },
  { q: "Pro·Max 는 언제 나오나요?", a: "준비 중입니다. 출시 알림을 신청하시면 가격과 시작일을 먼저 알려 드립니다." },
] as const;

export const SIGNUP_STEPS = ["계정", "메일 확인", "회사 정보", "규모", "확인"] as const;

// 랜딩 「시작은 이렇게 합니다」 — 셀프 가입 순서.
export const START_STEPS = [
  { title: "가입", desc: "이름·이메일·비밀번호만 넣고 확인 메일을 받습니다" },
  { title: "메일 확인", desc: "메일의 링크를 누르면 회사 정보 입력으로 이어집니다" },
  { title: "회사 정보", desc: "상호·대표자·전화를 넣으면 견적서·계약서에 그대로 들어갑니다" },
  { title: "첫 현장 등록", desc: "첫 견적서 링크를 복사해 고객에게 문자로 보냅니다" },
] as const;
